import { RadioButton } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import {
  labelContainerCss,
  legendCss,
  radioButtonCss,
  radioGroupCss,
  wrapperCss,
} from "./AllottedTimeButtonGroup.style";

export type AllottedTimeValue = 30 | 45 | 60 | 90;

interface AllottedTimeButtonGroupProps {
  value: AllottedTimeValue;
  onChange: (value: AllottedTimeValue) => void;
}

const RadioButtonWithTrackEvent = withTrackEvent(RadioButton);

const DURATION: AllottedTimeValue[] = [30, 45, 60, 90];

const AllottedTimeButtonGroup = ({
  value,
  onChange,
}: AllottedTimeButtonGroupProps) => {
  const isCheckedOption = (option: number) => {
    return option === value;
  };

  return (
    <fieldset css={wrapperCss}>
      <div css={labelContainerCss}>
        <legend css={legendCss}>
          Allotted time <span>(optional)</span>
        </legend>
        <p>Select how long you want the lesson to last</p>
      </div>
      <div
        role="radiogroup"
        aria-labelledby="allotted-time"
        css={radioGroupCss}
      >
        {DURATION.map((time) => (
          <RadioButtonWithTrackEvent
            __cssFor={{
              root: radioButtonCss(isCheckedOption(time)),
            }}
            key={time}
            checked={isCheckedOption(time)}
            label={`${time} min`}
            name="allotted-time"
            onChange={() => onChange(time)}
            value={String(time)}
            objectType={objectTypes.generatedTextAsset}
            actionName={actionNames.select}
            dataProps={{
              "data-qa-selector": `allotted-time-button-${time}`,
            }}
            streamProperties={{
              description: `Select ${time} min as allotted time for lesson plan`,
            }}
          />
        ))}
      </div>
    </fieldset>
  );
};

export default AllottedTimeButtonGroup;
